import { css } from '@lastbrand/web-ui-styled-system/css'

// Token-based twins of the legacy freeSwatchText / container__breadCrumb rem classes (which mis-scale at the 16px DS root).
export const freeSwatchDsClass = css({
  textStyle: 'body-12',
  lineHeight: '18px',
  textAlign: 'left',
  borderBottom: '1px solid token(colors.black)',
  cursor: 'pointer',
  paddingTop: 'space-8',
  // Legacy button is inline-block (underline = text width); the DS button reset makes it block,
  // so it stretches to the flex-column width. fit-content restores the legacy content-width underline.
  width: 'fit-content',
})

export const breadCrumbWrapperDsClass = css({
  paddingBottom: 'space-12',
  paddingTop: { base: 'space-12', lg: 0 },
})

export const quickAtcModalDsClass = css({ width: '100%' })

// Legacy `.container__error_message__miniPdpError` — mobile-only bottom margin on the mini-PDP
// quick-ATC error message (`!` mirrors legacy's `margin-bottom: 1.6rem !important`).
export const errorMessageMiniPdpDsClass = css({ lgDown: { marginBottom: 'space-16!' } })
